import { getSession } from '@nx-frontend/shared/api/services/user/get-session';

export async function getUserIdSessionFromCookies({
  sessionId,
  host,
}: {
  sessionId: string | undefined;
  host: string;
}): Promise<number> {
  if (!sessionId) {
    throw new Error('Session id not found');
  }
  const sessionData = await getSession({ sessionId, host });
  if (!sessionData.userId) {
    throw new Error('User id not found');
  }
  return sessionData.userId;
}
